import type { ChangeEvent, ReactNode } from "react"
import EntryFormField, {
  FIELD_CONTROL_CLASS,
} from "@/components/entry/EntryFormField"
import EntryFormSectionHeading from "@/components/entry/EntryFormSectionHeading"
import type { EntryGymErrors, EntryGymInput } from "@/domain/entry/model/Entry"

interface EntryGymFieldsProps {
  gym: EntryGymInput
  errors: EntryGymErrors
  onChange: (field: keyof EntryGymInput, value: string) => void
  /** 같은 카드 안에 덧붙일 입력 (신청 등록의 비밀번호 입력이 여기로 들어온다) */
  children?: ReactNode
}

export default function EntryGymFields({
  gym,
  errors,
  onChange,
  children = null,
}: Readonly<EntryGymFieldsProps>) {
  function onChangeName(event: ChangeEvent<HTMLInputElement>) {
    onChange("name", event.target.value)
  }

  function onChangeContactName(event: ChangeEvent<HTMLInputElement>) {
    onChange("contactName", event.target.value)
  }

  function onChangeContactPhoneNo(event: ChangeEvent<HTMLInputElement>) {
    onChange("contactPhoneNo", event.target.value)
  }

  return (
    <section className="app-card">
      <EntryFormSectionHeading
        step="01"
        title="체육관 정보"
        description="대회 관련 안내는 체육관 담당자에게 전달됩니다."
      />

      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <EntryFormField
          controlId="gym-name"
          label="체육관명"
          isRequired
          error={errors.name}
        >
          <input
            id="gym-name"
            type="text"
            value={gym.name}
            maxLength={50}
            onChange={onChangeName}
            placeholder="예: 신림국제 체육관"
            aria-invalid={Boolean(errors.name)}
            className={FIELD_CONTROL_CLASS}
          />
        </EntryFormField>

        <EntryFormField
          controlId="gym-contact-name"
          label="담당자명"
          isRequired
          error={errors.contactName}
        >
          <input
            id="gym-contact-name"
            type="text"
            value={gym.contactName}
            maxLength={20}
            onChange={onChangeContactName}
            placeholder="담당자 이름"
            aria-invalid={Boolean(errors.contactName)}
            className={FIELD_CONTROL_CLASS}
          />
        </EntryFormField>

        <EntryFormField
          controlId="gym-contact-phone-no"
          label="체육관 연락처"
          isRequired
          error={errors.contactPhoneNo}
        >
          <input
            id="gym-contact-phone-no"
            type="tel"
            inputMode="tel"
            value={gym.contactPhoneNo}
            maxLength={13}
            onChange={onChangeContactPhoneNo}
            placeholder="010-0000-0000"
            aria-invalid={Boolean(errors.contactPhoneNo)}
            className={FIELD_CONTROL_CLASS}
          />
        </EntryFormField>
      </div>

      {children}
    </section>
  )
}
